import moment from 'moment'

const HolidaysUtils = {

  getEaster(Y) {
    let C = Math.floor(Y / 100);
    let N = Y - 19 * Math.floor(Y / 19);
    let K = Math.floor((C - 17) / 25);
    let I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
    I = I - 30 * Math.floor((I / 30));
    I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
    let J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4);
    J = J - 7 * Math.floor(J / 7);
    let L = I - J;
    let M = 3 + Math.floor((L + 40) / 44);
    let D = L + 28 - 31 * Math.floor(M / 4);
    return Y + '-' + this.padout(M) + '-' + this.padout(D);
  },
  padout(number) {
    return (number < 10) ? '0' + number : number;
  }
};

export default {
  computed: {
    isDiwali() {
      let now = moment();
      const diwaliDates = [
        "2018-11-07",
        "2019-10-27",
        "2020-11-14",
        "2021-11-04",
        "2022-10-24",
        "2023-11-09",
        "2024-11-01",
        "2025-10-21"
      ];
      let isDiwali = false;
      for (let i = 0; i < diwaliDates.length; i++) {
        isDiwali = moment(diwaliDates[i], 'YYYY-MM-DD').isSame(now);
        i++;
      }
      return isDiwali;
    },
    isChristmas() {
      let curYear = moment().format('YYYY');
      let now = moment();
      let beforeTime = moment(curYear + '-12-10', 'YYYY-MM-DD');
      let afterTime = moment((curYear) + '-12-28', 'YYYY-MM-DD');
      return now.isBetween(beforeTime, afterTime);
    },
    isThanksGiving() {
      let now = moment();
      let curYear = moment().format('YYYY');
      return moment(curYear + '-11-22', 'YYYY-MM-DD').isSame(now)
    },
    isHalloween() {
      let now = moment();
      let curYear = moment().format('YYYY');
      return moment(curYear + '-10-31', 'YYYY-MM-DD').isSame(now);
    },
    isEaster() {
      let curYear = moment().format('YYYY');
      let now = moment();
      let easterDate = moment(HolidaysUtils.getEaster(curYear), 'YYYY-MM-DD');
      return now.isSame(easterDate, 'day');
    },
    isBreakfast() {
      let format = 'hh:mm:ss';
      let time = moment(), beforeTime = moment('05:00:00', format), afterTime = moment('10:29:59', format);
      return time.isBetween(beforeTime, afterTime);
    },
    isLunch() {
      let format = 'hh:mm:ss';
      let time = moment(), beforeTime = moment('10:30:00', format), afterTime = moment('16:59:59', format);
      return time.isBetween(beforeTime, afterTime);
    },
    isDinner() {
      let format = 'hh:mm:ss';
      let time = moment(), beforeTime = moment('17:00:00', format), afterTime = moment('23:59:59', format);
      return time.isBetween(beforeTime, afterTime);
    },
    isNight() {
      let format = 'hh:mm:ss';
      let time = moment(), beforeTime = moment('00:00:00', format), afterTime = moment('04:59:59', format);
      return time.isBetween(beforeTime, afterTime);
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Recipes/Mixins/Timings.js